export enum SwordLogic {
  Randomized,
  UncleAssured,
  Swordless
}
